import { Component, OnInit, TemplateRef, Input, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { HelpdeskComponent } from '../../Shared/helpdesk/helpdesk.component';
import { FormconfigService } from './formconfig.service';
import { DomSanitizer } from '@angular/platform-browser';
import { FormGroup, FormBuilder, Validators, FormArray, FormControl, ValidatorFn } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { formconfig } from './formconfig';
import { CommondialogComponent } from '../../../app/Shared/commondialog/commondialog.component';
import { FbeditorComponent } from './../../Shared/fbeditor/fbeditor.component';
import { DialogService } from 'ng2-bootstrap-modal';
import { ModalOptions, BsModalRef, BsModalService } from 'ngx-bootstrap';
import { LocalService } from '../../local.service';
//import { tableDragger} from 'table-dragger'
declare var $: any;


@Component({
  selector: 'app-formconfig',
  templateUrl: './formconfig.component.html',
  styleUrls: ['./formconfig.component.css'],
  providers: [FormconfigService, ToastrService]
})
export class FormconfigComponent implements OnInit {
  sendMenuId: number; p: number = 1; itemsPerPage: number = 10;
  sendPageName: string = 'Form Confiuration';
  database: string = ''; databaseName: string; databaseId: string;
  _formTemplateList: any; _formconfiglist: any = [];
  _formconfiglistactive: any = [];
  searchText: string; htmlData: any;
  _databaseListTmp: any = []; _databaseList: any = [];
  _action: string;
  _fieldAliasList: any;
  submitted: boolean;
  userid: number;
  currentForm: string;
  formConfigid: number;
  formConfigForm: FormGroup;
  confmsg: string;
  msg: string;
  btnName: string = 'Add Form'; _cleanedFormElement: any;
  formElement: any;
  fbEditorTouched: boolean;


  _actionRights: any;
  submitShow: boolean;
  readOnly: boolean;
  add: boolean;
  edit: boolean;
  delete: boolean;
  _menuId: any;
  key: string = 'formname'; //set default
  reverse: boolean = false;
  showall: boolean = true;
  showallstatus: boolean = false;
  federalDatabaseId: number = 0;
  formModalRef: BsModalRef;
  parsedFormElement: any;
  config: ModalOptions = {
    backdrop: 'static',
    keyboard: false,
    animated: true,
    class: 'modal-dialog-centered',
    ignoreBackdropClick: true
  };
  formConfigDisplayField = [];

  isdisplayorder = false;
  parsedFormShowElement = [];
  constructor(private formConfigService: FormconfigService,
    private toastr: ToastrService,
    private sanitizer: DomSanitizer,
    private _frmBuilder: FormBuilder,
    private route: ActivatedRoute,
    private _fbEditor: FbeditorComponent,
    private bsModelService: BsModalService,
    private dialogService: DialogService,
    private router: Router,
    private localService: LocalService) {

    if (this.router.getCurrentNavigation().extras.state != undefined) {
      localStorage.setItem('Form Templates_menuid', this.router.getCurrentNavigation().extras.state.menuid);
      localStorage.setItem('Form Templates_action', this.router.getCurrentNavigation().extras.state.action);
      this._menuId = this.router.getCurrentNavigation().extras.state.menuid;
      this.sendMenuId = this._menuId;
      this._actionRights = this.router.getCurrentNavigation().extras.state.action;
    }
    else {
      if (this._menuId == undefined)
        this._menuId = localStorage.getItem('Form Templates_menuid');
      this.sendMenuId = this._menuId;
      if (this._actionRights == undefined)
        this._actionRights = localStorage.getItem('Form Templates_action');
    }
    //var el = document.getElementById('tblForms');
    //var dragger = tableDragger(el, {
    //  mode: 'row',
    //  dragHandler: '.handle',
    //  onlyBody: true,
    //  animation: 300
    //});
    //dragger.on('drop', function (from, to) {
    //  console.log(from);
    //  console.log(to);
    //});
  }

  ngOnInit() {
    this.checkIsMenuMapped();

    this.formConfigForm = this._frmBuilder.group({
      formconfigname: ['', [Validators.required]],
      formconfigdesc: ['', [Validators.required]],
      dbid: ['', [Validators.required]],
      formtemplateid: ['', [Validators.required]]

    });


    this.fbEditorTouched = false;
    this._formTemplateList = [];
    this.searchText = '';
    this.htmlData = '';
    this._action = 'add';
    this.formElement = '';
    this.enableeditor();
    this.LoadFieldList();
    this.loadDatabaseList();
    this.loadFormConfig();
    this.loadFormTemplate();



    this.readOnly = false;
    this.add = false;
    this.edit = false;
    this.delete = false;
    this.submitShow = false;
    this.getActionRightsList();
    this.getFederalDatabaseId();

  }

  sort(key) {
    this.key = key;
    this.reverse = !this.reverse;
  }

  checkIsMenuMapped()
  {
    const arrays = this.localService.getJsonValue("menulist");
    const notauthorized = this.localService.getJsonValue("notauthorizedformconfig");
    let data = arrays.find(ob => ob['name'] === 'Form Configuration');
    if((data == undefined || data =='') && (notauthorized!=="true"))
    {
      this.localService.setJsonValue("notauthorizedformconfig","true");
      this.toastr.error('You are not authorized to access this page.');
      this.router.navigate(["home"]);
    }
    if(notauthorized=="true"){
      this.localService.setJsonValue("notauthorizedformconfig",null);
      this.router.navigate(["home"]);      
    }
  }

  getActionRightsList() {
    var btnToEnable = JSON.parse(this._actionRights);
    if (btnToEnable.length > 0) {
      btnToEnable.forEach(d => {
        if (d != undefined) {
          if (d == 1)
            this.readOnly = true;
          else if (d == 2) {
            this.readOnly = true;
            this.add = true;
            this.submitShow = true;
          }
          else if (d == 3) {
            this.readOnly = true;
            this.edit = true;
            // this.submitShow = true;
          }
          else if (d == 4) {
            this.readOnly = true;
            this.delete = true;
          }
        }
      });
    }
  }

  get formdata() { return this.formConfigForm.controls; }

  getfrmValue($event) {
    this.formElement = $event;
  }

  editorTouched() {
    this.fbEditorTouched = true;

    // this._fbEditor.get();
  }

  loadDatabaseList() {

    this.formConfigService.getDatabase().subscribe(res => {
      //var allData = res.find(y => y.active == 1);
      var allData = res;

      allData.forEach(data => {
        if (data.active != 0) {
          this._databaseListTmp.push({ databaseid: data.databaseid, database: data.database })
        }
      });

      this._databaseList = JSON.parse(JSON.stringify(this._databaseListTmp));


      this.formConfigForm.controls['dbid'].setValue(0);

      this.database = this.route.snapshot.paramMap.get('db');

      if (this.database != null) {
        var a = this.database.split('*');
        this.databaseId = a[0];
        this.databaseName = a[1];
        this.formConfigForm.controls['dbid'].setValue(this.databaseId);
      }
      else
        this.formConfigForm.controls['dbid'].setValue(0);




    }, error => { this.toastr.error('Error while getting the database data'); });

  }

  controlNameChangeUpdate(newformdata, oldformdata) {
    if ((newformdata != undefined) && (newformdata != null)) {
      var newarr = JSON.parse(newformdata);
      var oldarr = JSON.parse(oldformdata);
      var totalCount = newarr.length;
      if (newarr.length > 0) {
        newarr.forEach((item, index) => {
          var s = oldarr.filter(e => e.type == item.type && e.label === item.label);
          if ((s != undefined) && (s.length == 0)) {
            var alias = this._fieldAliasList.filter(e => e.fieldlabel == item.type);
            if ((item.name != undefined) && (item.formcontrolname == undefined)) {
              if (alias.length != 0) {
                if (item.label == undefined) {
                  if (item.type == 'checkbox-group')
                    item.label = item.values[0].label;
                }
                var name = alias[0].fieldalias + (item.label === undefined ? '' : item.label) + totalCount;
                item.name = name;
              }
              else {
                item.name = item.label + totalCount;
              }
              totalCount = totalCount + 1;
            }
            if ((item.name == undefined) && (item.formcontrolname == undefined))//if name is empty
            {
              if (alias.length != 0) {
                var name = alias[0].fieldalias + (item.label === undefined ? '' : item.label) + totalCount;
                item.name = name;
              }
              else {
                item.name = item.label + totalCount;
              }
              totalCount = totalCount + 1;
            }
            item.name = this.removeSpace(item.name);
            if (item.name != undefined) {
              var txt = this.removeSpecialCharacters(item.name);
              newarr[index]["formcontrolname"] = txt;
            }
          }
          else {
            if (s[0].formcontrolname != undefined && s[0].formcontrolname != null) {
              var txt = this.removeSpecialCharacters(s[0].formcontrolname);
              newarr[index]["formcontrolname"] = txt;
              newarr[index]["name"] = s[0].name;
              if (s[0].description != undefined) {
                newarr[index]["description"] = s[0].description;
              }
            }
              else {
              newarr[index]["formcontrolname"] = item.name;
            }
          }
          if (((item.type == "select") && (item.description == 'Masters')) || ((item.type == "radio-group") && (item.description == 'Masters')) ||
            ((item.type == "checkbox-group") && (item.description == 'Masters') && (item.values.length > 1))) {
            var valueList = item.values;
            if ((valueList != undefined) && (valueList.length != 0)) {
              var s = valueList.filter(e => e.selected == true);
              if (s != undefined || s.length != 0) {
                newarr[index]["tablename"] = s[0].label;
              }
            }
          }
if (item.type == "file") {
            newarr.push({ "type": "hidden", "name": item.formcontrolname + 'size', "formcontrolname": item.formcontrolname + 'size' });
          }
        });
        return JSON.stringify(newarr);
      }
    }
  }

  loadFormTemplate() {

    this.formConfigService.getFormTemplates().subscribe(res => {
      // this._formTemplateList = res.find(y => y.active == 1);     
      this._formTemplateList = res.filter(e => e.active == 1);

      this.formConfigForm.controls['formtemplateid'].setValue(0);

    }, error => { this.toastr.error('Error while getting the form template data'); })
  }

  LoadFieldList() {
    this.formConfigService.getFieldAlias().subscribe((res) => {
      if (res != undefined) {
        this._fieldAliasList = res;
      }
    });
  }

  loadFormConfig() {
    this._formconfiglist = [];
    this._formconfiglistactive = [];
    this.formConfigService.getFormConfig().subscribe(res => {
      this._formconfiglist = res;
      if (this.showallstatus == true) {
        this._formconfiglist.forEach(data => {
          if (data.active == 1) {
            this._formconfiglistactive.push(data);
          }
        });
        this._formconfiglist = [];
        this._formconfiglist = this._formconfiglistactive;
      }
    }, error => { this.toastr.error('Error while getting the form Config  data'); })
  }

  getactiveinactive(showallp) {
    this._formconfiglistactive = [];
    this.showall = showallp;
    this.showallstatus = showallp;
    if (this.showall == true) {
      this.showall = false;
      this._formconfiglist.forEach(data => {
        if (data.active == 1) {
          this._formconfiglistactive.push(data);
        }
      });
      this._formconfiglist = [];
      this._formconfiglist = this._formconfiglistactive;
    }
    else {
      this.showall = true;
      this._formconfiglist = [];
      this.loadFormConfig();
    }
  }

  enableeditor() {
    document.getElementById("fbeditor").style.pointerEvents = "auto";

  }

  disableeditor() {

    document.getElementById("fbeditor").style.pointerEvents = "none";

  }

  onChange(eve) {

    if (eve.currentTarget.value == '0') {
      this._fbEditor.clearBuilder();
    }

    //this.enableeditor();
    var selectedValue = eve.target.value;
    if (this._formTemplateList.length != 0) {
      var s = this._formTemplateList.filter(e => e.formtemplateid == selectedValue);
      if ((s != undefined) && (s.length != 0)) {
        this.formConfigForm.value.htmldata = s[0].htmldata;
        this.htmlData = s[0].htmldata;
        this._fbEditor.setValue(s[0].htmldata);
      }
      else
        this.htmlData = '';
    }

  }

  postFormConfig(frmConfig: formconfig) {

    this.submitted = true;
    if (this.formConfigForm.valid) {
      if (frmConfig.dbid == 0) {
        this.toastr.error('Database should be selected');
        return;
      }
      if (frmConfig.formtemplateid == 0) {
        this.toastr.error('form Template should be selected');
        return;
      }
      let formConfigAdd = JSON.parse(frmConfig.formConfigAdd);
      let checked = formConfigAdd.filter(x => x.displaystatus == 1);
      if (checked.length == 0) {
        this.toastr.error('Please select atleast one field');
        return;
      }
      //this.userid = +localStorage.getItem('userid');
      this.userid = +this.localService.getJsonValue('userid')
      if (this._action == 'add') {
        frmConfig.createdby = this.userid;
        frmConfig.active = 1;
        //adding hidden variable for federal database
        if (frmConfig.dbid == this.federalDatabaseId) {
          var s = JSON.parse(this.formElement);
          if (s.length != 0) {
            s.push({ "type": "hidden", "name": "issendnotification", "formcontrolname": "issendnotification" });
          }
          this.formElement = JSON.stringify(s);
        }

       // this._cleanedFormElement = this.controlNameChange(this.formElement);
        this.formConfigForm.value.htmldata = this._cleanedFormElement;
        this.formConfigService.Post(frmConfig).subscribe(
          (res) => {
            if (res.body != 0) {
              this.toastr.success('Data added successfully');
              this.loadFormConfig();
              this.clearForm();
              this.formModalRef.hide();
            //  this.disableeditor();
            }
            else { this.toastr.error('Form Config exists already'); }
          }, error => {
            this.toastr.error('Form configuration not completed successfully');
            //this.toastr.error(error);
            console.log(error);
          });
      }

      if (this._action == 'update') {
        frmConfig.modifiedby = this.userid;
        frmConfig.active = 1;
        frmConfig.formconfigid = this.formConfigid;
        //adding hidden variable for federal database
        if (frmConfig.dbid == this.federalDatabaseId) {
          console.log(this.formElement);
          var s = JSON.parse(this.formElement);
          if (s.length != 0) {
            var hdnexists = s.filter(e => e.type == 'hidden' && e.name == 'issendnotification');
            if (hdnexists.length == 0)
              s.push({ "type": "hidden", "name": "issendnotification", "formcontrolname": "issendnotification" });
          }
          this.formElement = JSON.stringify(s);
        }
       // this._cleanedFormElement = this.controlNameChangeUpdate(this.formElement, this.htmlData);
        this.formConfigForm.value.htmldata = this._cleanedFormElement;
        this.formConfigService.Put(frmConfig).subscribe(
          (res) => {
            if (res.body != 0) {
              this.toastr.success('Data updated successfully');
              this.loadFormConfig();
              this.clearForm();
              this.formModalRef.hide();
             // this.disableeditor();
            }
            else { this.toastr.error('Form Config exists already'); }
          }, error => {
            this.toastr.error('Form configuration not completed successfully');
            //this.toastr.error(error);
            console.log(error);
          });
      }
    }
  }

  clearForm() {
    this._action = 'add';
    this.submitted = false;
    this.formConfigForm.reset();
    this.htmlData = "";
    this.currentForm = "";
    this.btnName = 'Add Form';
    this.fbEditorTouched = false;
    this._fbEditor.clearBuilder();
    this.enableeditor();
    this.formElement = ''; this._cleanedFormElement = '';
    this.formConfigForm.controls['dbid'].setValue(0);
    this.formConfigForm.controls['formtemplateid'].setValue(0);
   // this.disableeditor();
    
    if (this.add == true)
      this.submitShow = true;
    else
      this.submitShow = false;

  }

  controlNameChange(data) {
    var arr1 = [];
    if ((data != undefined) && (data != null)) {
      var arr = JSON.parse(data);
      //get list of field alias name   
      if (arr.length > 0) {
        arr.forEach((item, index) => {
          if (item.name != 'issendnotification' && item.type != 'hidden') {
            if (item.name != undefined) {
              var alias = this._fieldAliasList.filter(e => e.fieldlabel == item.type);
              var ind = index + 1;
              if (alias.length != 0) {
                //if label is undefined
                if (item.label == undefined) {
                  if (item.type == 'checkbox-group')
                    item.label = item.values[0].label;
                }
                var name = alias[0].fieldalias + (item.label === undefined ? '' : item.label) + ind;
                item.name = name;
              }
              else {
                item.name = item.label + ind;
              }
              var b = '';
              var replaceTxt = item.name.replace('&nbsp;', " ")
              var removeSpace = replaceTxt.split(/(\s+)/);
              if (removeSpace.length != 0) {
                removeSpace.forEach(a => {
                  b = b + a.trim();
                });
                item.name = b.trim();
              }
            }
            else {
              var alias = this._fieldAliasList.filter(e => e.fieldlabel == item.type);
              var ind = index + 1;
              if (alias.length != 0) {
                var name = alias[0].fieldalias + (item.label === undefined ? '' : item.label) + ind;
                item.name = name;
              }
              else {
                item.name = item.label + ind;
              }
              var b = '';
              var replaceTxt = item.name.replace('&nbsp;', " ")
              var removeSpace = replaceTxt.split(/(\s+)/);
              if (removeSpace.length != 0) {
                removeSpace.forEach(a => {
                  b = b + a.trim();
                });
                item.name = b.trim();
              }
            }
            if (item.name != undefined) {
              var txt = this.removeSpecialCharacters(item.name);
              arr[index]["formcontrolname"] = txt;
            }
            if (((item.type == "select") && (item.description == 'Masters')) || ((item.type == "radio-group") &&
              (item.description == 'Masters')) || ((item.type == "checkbox-group") && (item.description == 'Masters') && (item.values.length > 1))) {
              var valueList = item.values;
              if ((valueList != undefined) && (valueList.length != 0)) {
                var s = valueList.filter(e => e.selected == true);
                if (s != undefined || s.length != 0) {
                  arr[index]["tablename"] = s[0].label;
                }
              }
            }
            if (item.type == "file") {
              arr.push({ "type": "hidden", "name": item.formcontrolname + 'size', "formcontrolname": item.formcontrolname + 'size' });
            }
          }
        });
        return JSON.stringify(arr);
      }
    }

  }

  removeSpecialCharacters(text) {
    var cleanedTxt = text.replace(/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/g, '');
    return cleanedTxt;
  }

  editformconfig(formconfigid, formconfigname, action) {
    this.submitShow = true;
    if ((this.currentForm != '') && ((this.formConfigForm.touched == true) || (this.fbEditorTouched == true))) {
      this.confirmation(formconfigid, formconfigname, action);
    }
    else {
      this.enableeditor();
       this.btnName = 'Update';
      this._action = 'update';
      this.currentForm = formconfigname;
      this.formConfigid = formconfigid;
      this.getFormConfigDisplayField(formconfigid);
      this.formConfigForm.value.formconfigid = formconfigid;

      if (this._formconfiglist.length != 0) {
        var s = this._formconfiglist.filter(e => e.formconfigid == formconfigid);
        if ((s != undefined) && (s.length != 0)) {
          this.formConfigForm.controls['formconfigname'].setValue(s[0].formconfigname);
          this.formConfigForm.controls['formconfigdesc'].setValue(s[0].formconfigdesc);
          this.formConfigForm.controls['dbid'].setValue(s[0].dbid);
          this.formConfigForm.controls['formtemplateid'].setValue(s[0].formtemplateid);
          this.formConfigForm.value.htmldata = s[0].htmldata;
          this.htmlData = s[0].htmldata;
          this._fbEditor.setValue(s[0].htmldata);
        }
      }
    }

  }

  statusChange(id, option) {
    //this.userid = +localStorage.getItem('userid');
    this.userid = +this.localService.getJsonValue('userid')
    if (option == 'activate') {
      this.confmsg = "activate";
      this.formConfigForm.value.active = 1;
      this.msg = "Record activated successfully";
    }
    else {
      this.confmsg = "deactivate";
      this.formConfigForm.value.active = 0;
      this.msg = "Record deactivated successfully";
    }
    this.formConfigForm.value.formconfigid = id;
    this.formConfigForm.value.modifiedby = 81//this.userid;
    let showpopup = this.dialogService.addDialog(CommondialogComponent,
      {
        title: 'Please Confirm',
        message: 'Are you sure you want to ' + this.confmsg + ' this record ?',
        hclass: 'modelsuccess',
        oktext: 'Yes',
        canceltext: 'No',
        okshow: true,
        cancelshow: true

      }).subscribe((isConfirmed) => {
        if (isConfirmed) {
          this.formConfigService.Delete(this.formConfigForm.value).subscribe(
            (res) => {
              if (res.body != 0) {
                this.toastr.success(this.msg);
                this.loadFormConfig();
              }
            }, error => {
             // console.log(error);
              this.toastr.error(error);
            });
        }
      });
  }

  confirmation(formconfigid, formconfigname, action) {

    let showpopup = this.dialogService.addDialog(CommondialogComponent,
      {
        title: 'Confirmation',
        message: 'Would you like to save changes? ' + this.currentForm,
        hclass: 'modelsuccess',
        oktext: 'Yes',
        canceltext: 'No',
        okshow: true,
        cancelshow: true
      }).subscribe((isConfirmed) => {
        if (isConfirmed) {
          //this.postFormConfig(this.formConfigForm.value);
          $(document.getElementById("btnSave")).click();
        }
        else {
          this.currentForm = '';
          this.formConfigForm.markAsUntouched();
          this.fbEditorTouched = false;
          this.editformconfig(formconfigid, formconfigname, action);
        }
      });

  }

  removeSpace(givenText) {
    var b = '';
    var replaceTxt = givenText.replace('&nbsp;', " ")
    var removeSpace = replaceTxt.split(/(\s+)/);
    if (removeSpace.length != 0) {
      removeSpace.forEach(a => {
        b = b + a.trim();
      });
    }
    return b.trim();
  }

  getFederalDatabaseId() {
    this.formConfigService.getFederalDatabaseId().subscribe((res) => {
      if (res != undefined && res != null) {
        this.federalDatabaseId = res;
      }
    })
  }

  openFormPopup(mailgrpPopup: TemplateRef<any>, frmConfig) {
    if (this.formConfigForm.valid) {
      if (frmConfig.dbid == 0) {
        this.toastr.error('Database should be selected');
        return;
      }
      if (frmConfig.formtemplateid == 0) {
        this.toastr.error('form Template should be selected');
        return;
      }
		if (frmConfig.dbid == this.federalDatabaseId) {
        console.log(this.formElement);
        var s = JSON.parse(this.formElement);
        if (s.length != 0) {
          var hdnexists = s.filter(e => e.type == 'hidden' && e.name == 'issendnotification');
          if (hdnexists.length == 0)
            s.push({ "type": "hidden", "name": "issendnotification", "formcontrolname": "issendnotification" });
        }
        this.formElement = JSON.stringify(s);
      }
      let res: any;
      res = this.dataValidation(this.formElement);
      if (res != '') {
        this.toastr.error('Master data should get selected for ' + res);
        return;
      }
      //this._cleanedFormElement = this.controlNameChangeUpdate(this.formElement, this.htmlData);
      this._cleanedFormElement = this._action == 'add' ? this.controlNameChange(this.formElement) : this.controlNameChangeUpdate(this.formElement, this.htmlData);
      this.formConfigForm.value.htmldata = this._cleanedFormElement;											 
      //this.userid = +localStorage.getItem('userid');
      this.userid = +this.localService.getJsonValue('userid')
      this.formModalRef = this.bsModelService.show(mailgrpPopup, this.config);
      const aa = document.getElementsByClassName('modal-content');
      aa[0].classList.remove("modal-content");
      this.parsedFormElement = JSON.parse(this.formConfigForm.value.htmldata);
     this.parsedFormElement.forEach((element, index) => {
        element['displaystatus'] = this._action == 'update' ? this.getDisplayStatus(element) : false;
        element['sequence'] = index + 1;
        //element['formconfigid'] = formConfigid;
       element['active'] = true;
       element['displayorder'] = this._action == 'update' ? this.getDisplayOrder(element) : null;
      });
    }
  }


  formConfigSubmit(parsedFormElement, frmConfig) {
    let postValue = [];
    console.log(parsedFormElement);
    this.isdisplayorder = false;
    //this.parsedFormShowElement.forEach(element => {
    //  parsedFormElement.forEach(innerElement => {
    //    if (innerElement.formcontrolname == element.formcontrolname) {
    //      innerElement.displayorder = element.displayorder;
    //    }
    //  });
    //});
    parsedFormElement.forEach(element => {
      if (element.type != 'hidden' && element.type != 'header') {
        postValue.push({
          formcontrolname: element.formcontrolname,
          type: element.type,
          name: element.label,
          displaystatus: element.displaystatus ? 1 : 0,
          sequence: element.sequence,
          //formconfigid: element.formconfigid,
          tablename: element.tablename,
          //createdby: localStorage.getItem('userid'),
          createdby: this.localService.getJsonValue('userid'),
          createdon: new Date(),
          active: element.active ? 1 : 0
         // displayorder: element.displayorder
        });
      }
    });
    frmConfig['formConfigAdd'] = JSON.stringify(postValue);
    this.postFormConfig(frmConfig);

  }

  checkChange(event) {
    this.parsedFormElement.forEach(formElement => {
      if (formElement.type != 'hidden' && formElement.type != 'header') {
        formElement.displaystatus = event.target.checked;
      }
    });
  }

 getFormConfigDisplayField(formConfigid) {
    
    this.formConfigDisplayField = [];
    this.formConfigService.getFormConfigDisplayField(formConfigid).subscribe((result) => {
      console.log(result);
      this.formConfigDisplayField = result;
    });
  }

  getDisplayStatus(element) {
    let value = this.formConfigDisplayField.findIndex(x => x.formcontrolname == element.formcontrolname);
    if (value != -1) {
      return this.formConfigDisplayField[value].displaystatus == 1 ? true : false;
    } else {
      return false;
    }
  }


  dataValidation(data) {
    var label = '';
    var controlList = JSON.parse(data);
    if ((controlList != undefined) && (controlList.length != 0)) {
      controlList.forEach(item => {
        if (((item.type == "select") && (item.description == 'Masters')) || ((item.type == "radio-group") && (item.description == 'Masters')) || ((item.type == "checkbox-group") && (item.description == 'Masters') && (item.values.length > 1))) {
          var valueList = item.values;
          if ((valueList != undefined) && (valueList.length != 0)) {
            var s = valueList.filter(e => e.selected == true);
            if (s == undefined || s.length == 0) {
              // this.toastr.error('Master data should get selected for ' + item.label);
              label = item.label;
              return label;
            }
          }
        }
      });
    }
    return label;
  }

  getDisplayOrder(element) {
    let value = this.formConfigDisplayField.findIndex(x => x.formcontrolname == element.formcontrolname);
    if (value != -1) {
      let displayorder = this.formConfigDisplayField[value].displayorder;
      return displayorder == undefined || displayorder == null ? null : displayorder;
    } else {
      return false;
    }
  }

  changeaddform(event) {

    if (event == 'next') {
      let getdisplaystatusrecords = this.parsedFormElement.filter(x => x.displaystatus == true);
      if (getdisplaystatusrecords.length > 0) {
        this.isdisplayorder = true;
        this.parsedFormShowElement = getdisplaystatusrecords;
      } else {
        this.toastr.warning('Please select atleast one field to show in dashboard');
      }
    } else {
      this.isdisplayorder = false;
    }
  }
  checkorderposition(event, index) {
    if (event.target.value != '') {
      let samevalue = this.parsedFormShowElement.filter(x => x.displayorder == event.target.value);
      if (samevalue.length > 1) {
        this.toastr.warning('The given order is already exists');
        this.parsedFormShowElement[index].displayorder = '';
      }
      if (event.target.value == 0) {
        this.parsedFormShowElement[index].displayorder = '';
      }
    }
  }

  numbervalidate(event) {
    // let regxpat = new RegExp(/^(\d|,)*\d*$/);
    // if (!regxpat.test(event.target.value)) {
    //   // event.preventDefault();
    // }

    var charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }

  }

}
